<template>
  <model-form
    ref="modelForm"
    :model="inventoryItemAdjustment"
    :read-only="inventoryItemAdjustment.readonly"
    modal-type="modal"
    width="600px"
    @change="$emit('change')"
  >
    <div class="row q-col-gutter-md">
      <q-select
        v-model="inventoryItemAdjustment.adjustmentType"
        :options="inventoryItemAdjustment.adjustmentTypeOptions"
        :readonly="inventoryItemAdjustment.readonly"
        :rules="[val => !!val || 'Field is required']"
        bottom-slots
        class="col"
        emit-value
        label="Type of Adjustment"
        map-options
      />
    </div>
    <div
      v-if="inventoryItemAdjustment.showAdjustmentReason"
      class="row q-col-gutter-md"
    >
      <q-input
        v-model="inventoryItemAdjustment.adjustmentReason"
        :readonly="inventoryItemAdjustment.readonly"
        :rules="inventoryItemAdjustment.adjustmentReasonRules"
        bottom-slots
        class="col"
        :label="inventoryItemAdjustment.isMisc ? 'Reason' : 'Reason (Optional)'"
      />
    </div>
    <div
      class="row q-col-gutter-md"
    >
      <q-select
        v-model="inventoryItemAdjustment.locationOrRegisterStation"
        :display-value="inventoryItemAdjustment.locationOrRegisterStationDisplayValue"
        :options="locationOrRegisterStationOptions"
        option-label="inventoryStrategyEntityDisplayName"
        :readonly="inventoryItemAdjustment.readonly"
        :rules="[_val => inventoryItemAdjustment.hasLocationOrRegisterStation || 'Field is required']"
        bottom-slots
        class="col"
        :label="inventoryItemAdjustment.isTransfer ? 'From Location' : 'Location'"
        clearable
      />
      <q-select
        v-if="inventoryItemAdjustment.isTransfer"
        v-model="inventoryItemAdjustment.transferLocationOrRegisterStation"
        :display-value="inventoryItemAdjustment.transferLocationOrRegisterStationDisplayValue"
        :options="transferLocationOrRegisterStationOptions"
        option-label="inventoryStrategyEntityDisplayName"
        :readonly="inventoryItemAdjustment.readonly"
        :rules="[_val => inventoryItemAdjustment.hasTransferLocationOrRegisterStation || 'Field is required']"
        bottom-slots
        class="col"
        label="To Location"
        clearable
      />
    </div>
    <div class="row q-col-gutter-md">
      <div class="col">
        <inventory-item-adjustment-unit-select
          :inventory-item-adjustment="inventoryItemAdjustment"
          :dense="false"
        />
      </div>
      <q-input
        v-model.number="inventoryItemAdjustment.unitQuantity"
        :min="0"
        :readonly="inventoryItemAdjustment.readonly"
        :rules="inventoryItemAdjustment.unitQuantityRules"
        bottom-slots
        :class="inventoryItemAdjustment.isReceipt ? 'col-3' : 'col-6'"
        label="Quantity"
        type="number"
      />
      <q-input
        v-if="inventoryItemAdjustment.isReceipt"
        v-model.number="inventoryItemAdjustment.cost"
        :readonly="inventoryItemAdjustment.readonly"
        class="col-3"
        label="Cost"
        :prefix="currentCircuit.localeCurrencySymbol"
        type="number"
        step="0.01"
        bottom-slots
      />
    </div>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'InventoryItemAdjustmentForm',
  components: {
    ModelForm,
    InventoryItemAdjustmentUnitSelect: defineAsyncComponent(() => import('src/modules/admin/inventory-item/components/InventoryItemAdjustmentUnitSelect'))
  },
  configuration: ['currentCircuit', 'currentSite', 'locations', 'registerStations'],
  emits: ['change'],
  computed: {
    registerStationOptions () {
      return _.filter(this.registerStations.data, { archivedAt: null })
    },
    locationOrRegisterStationOptions () {
      const locationsAndRegisterStations = []

      if (!this.inventoryItemAdjustment.inventoryItem) return locationsAndRegisterStations

      _.each(this.locations.data, location => {
        const allowAtLocation = !!this.currentSite.activeInventoryStrategy?.allowInventoryAtLocation(location.id)
        const isAlreadySelected = location.id === this.inventoryItemAdjustment.transferLocationId

        if (allowAtLocation && !isAlreadySelected) {
          locationsAndRegisterStations.push(location)
        }
      })

      _.each(this.registerStationOptions, registerStation => {
        const allowAtRegisterStation = !!this.currentSite.activeInventoryStrategy?.allowInventoryAtRegisterStation(registerStation.id, this.inventoryItemAdjustment.inventoryItem)
        const isAlreadySelected = registerStation.id === this.inventoryItemAdjustment.transferRegisterStationId

        if (allowAtRegisterStation && !isAlreadySelected) {
          locationsAndRegisterStations.push(registerStation)
        }
      })

      return locationsAndRegisterStations
    },
    transferLocationOrRegisterStationOptions () {
      const locationsAndRegisterStations = []

      if (!this.inventoryItemAdjustment.inventoryItem) return locationsAndRegisterStations

      _.each(this.locations.data, location => {
        const allowAtLocation = !!this.currentSite.activeInventoryStrategy?.allowInventoryAtLocation(location.id)
        const isAlreadySelected = location.id === this.inventoryItemAdjustment.location?.id

        if (allowAtLocation && !isAlreadySelected) {
          locationsAndRegisterStations.push(location)
        }
      })

      _.each(this.registerStationOptions, registerStation => {
        const allowAtRegisterStation = !!this.currentSite.activeInventoryStrategy?.allowInventoryAtRegisterStation(registerStation.id, this.inventoryItemAdjustment.inventoryItem)
        const isAlreadySelected = registerStation.id === this.inventoryItemAdjustment.registerStation?.id

        if (allowAtRegisterStation && !isAlreadySelected) {
          locationsAndRegisterStations.push(registerStation)
        }
      })

      return locationsAndRegisterStations
    }
  },
  models: {
    inventoryItemAdjustment: {
      adjustmentTypes: true,
      inventoryItemUnit: true,
      inventoryItem: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
